import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Input,
} from '@sr/ui-library';
import { Control, useWatch } from 'react-hook-form';
import { getAddressFieldLabels } from '../../shared/addressLabels';
import { countryAwareRequiredString } from '../../shared/countryAwareStringSchema';
import { WORKSPACE_DETAILS_FORM_FIELDS } from '../../shared/fieldNames';
import { WorkspaceDetailsFormValues } from '../../shared/types';

interface AddressPostcodeFieldProps {
  control: Control<WorkspaceDetailsFormValues>;
}

/** Postcode/ZIP — label follows the selected address country. */
export const AddressPostcodeField = ({
  control,
}: AddressPostcodeFieldProps) => {
  const country = useWatch({
    control,
    name: WORKSPACE_DETAILS_FORM_FIELDS.addressCountry,
  });
  const label = getAddressFieldLabels(country).postcode;

  return (
    <FormField
      name={WORKSPACE_DETAILS_FORM_FIELDS.addressPostcode}
      control={control}
      render={({ field }) => (
        <FormItem>
          <FormLabel asterisk>{label}</FormLabel>
          <FormControl>
            <Input {...field} placeholder={`Enter ${label.toLowerCase()}`} />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

AddressPostcodeField.schema = countryAwareRequiredString(
  'postcode',
  WORKSPACE_DETAILS_FORM_FIELDS.addressPostcode,
);
